if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // cart-notification OR cart-drawer component
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Clear previous error
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((res) =>
            res.json().then((data) => ({
              ok: res.ok,
              status: res.status,
              data,
            }))
          )
          .then(({ ok, status, data }) => {
            if (!ok) {
              // -------- ERROR PATH (includes 422 “Only 1 item was added…” case) --------
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: data.errors || data.description,
                message: data.message,
              });

              this.handleErrorMessage(
                data.description ||
                  data.message ||
                  'There was a problem adding this product to the cart.'
              );

              // Even on error, Shopify might have changed the cart (e.g. added 1 item).
              // So force-refresh cart sections from the server.
              this.updateCartSectionsFromServer();

              // We do NOT permanently disable the button here.
              // Leave this.error = false so the button is re-enabled in finally.
              this.error = false;
              return;
            }

            // ------------------- SUCCESS PATH (HTTP 2xx) -------------------
            if (!this.cart) {
              // No AJAX cart, fallback redirect
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: data,
            });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(data);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // This re-renders cart icon, drawer, etc. on normal success
              this.cart.renderContents(data);
            }
          })
          .catch((e) => {
            console.error('Error in /cart/add:', e);
            this.handleErrorMessage(
              'Something went wrong. Please try again in a moment.'
            );
            // Also try to sync cart UI with the server
            this.updateCartSectionsFromServer();
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            // Re-enable button unless we explicitly left it disabled
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            const spinnerFinal = this.querySelector('.loading__spinner');
            if (spinnerFinal) spinnerFinal.classList.add('hidden');
          });
      }

      /**
       * Force-refresh cart sections & item count from the server.
       * This is important for cases like:
       * "Only 1 item was added to your cart due to availability."
       */
      updateCartSectionsFromServer() {
        if (!this.cart) return;

        const sectionsToRender = this.cart
          .getSectionsToRender()
          .map((section) => section.id);

        // 1) Get full cart JSON (for item_count, totals, etc.)
        // 2) Get fresh HTML for cart-related sections
        Promise.all([
          fetch('/cart.js').then((res) => res.json()),
          fetch(
            `${window.location.pathname}?sections=${sectionsToRender.join(',')}`
          ).then((res) => res.json()),
        ])
          .then(([cartData, sectionsHtml]) => {
            // Build an object shaped like the normal /cart/add success response,
            // so cart-drawer / cart-notification can reuse renderContents().
            const parsedState = {
              sections: sectionsHtml,
              cart: cartData,
              item_count: cartData.item_count,
            };

            this.cart.renderContents(parsedState);
          })
          .catch((err) => {
            console.error('Error updating cart sections after error:', err);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}